import React, { useState, useEffect } from 'react';
import './hub.css';

const DestinationsBlock = () => {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDestinations();
  }, []);

  const fetchDestinations = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/destinations');
      const data = await response.json();
      
      if (data.success) {
        setDestinations(data.data);
      } else {
        setError('Не удалось загрузить направления');
      }
    } catch (err) {
      console.error('Ошибка загрузки:', err);
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="destinations-loading">
        <div className="spinner-small"></div>
        <p>Загрузка направлений...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="destinations-error">
        <i className="fa fa-exclamation-circle"></i>
        <p>{error}</p>
        <button onClick={fetchDestinations} className="retry-small">
          <i className="fa fa-refresh"></i> Повторить
        </button>
      </div>
    );
  }

  return (
    <div className="content-section destinations-section">
      <h3 className="section-title">
        <span className="title-icon">🌍</span>
        Направления
      </h3>
      <p className="destinations-description">
        У нас имеется обширный список направлений как внутри России, так и в
        страны Ближнего Востока и Азии из:
      </p>
      <div className="destinations-grid">
        {destinations.map((dest) => (
          <a 
            key={dest.icao_code}
            href={`/airport/${dest.icao_code}`} 
            className="destination-card"
            title={`Расписание рейсов из/в ${dest.city_rus}`}
          >
            <div className="destination-icon">
              <i className="fa fa-map-marker" aria-hidden="true"></i>
            </div>
            <div className="destination-info">
              <span className="destination-city">{dest.city_rus}</span>
              <span className="destination-airport">{dest.name_rus}</span>
              <span className="destination-code">{dest.icao_code}</span>
            </div>
            <div className="destination-arrow">
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default DestinationsBlock;